<template>
    <div
        :data-uniqueid=uniqueId
        :id="'myPopover' + uniqueId"
        :ref="'myPopover' + uniqueId"
        @hide-other-popins="hidePopin"
        @mouseover="getUser(id); hideOtherPopins(uniqueId); stillOn = true"
        @mouseout="stillOn = false"
        v-model="userData"
        data-bs-toggle="popover"
        data-bs-placement="auto"
        data-bs-trigger="manual"
        data-bs-html="true"
    >
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'user-popin-component',

    emits: ['hide-other-popins'],

    props: {
        uniqueId: String,
        userId: Number,
    },

    data() {
        return {
            ajaxReq: '',
            id: this.userId,
            popover: null,
            popoverInst: null,
            show: false,
            stillOn: false,
            userData: {},
        }
    },

    mounted() {
        this.popover = document.querySelector(`[data-uniqueid="${this.uniqueId}"]`);
        this.popoverInst = bootstrap.Popover.getInstance(this.popover);
    },

    created() {
        this.$root.$on('hide-other-popins', this.hidePopin);
    },

    methods: {
        addListeners(popover) {
            const popinWindow = document.querySelector(`.popinWindow${this.uniqueId}`);

            popinWindow.addEventListener('mouseleave', () => {
                this.popoverInst.hide();
                this.show = false;

            });

            popinWindow.addEventListener('mouseover', () => {
                this.show = true;
            });

            popover.addEventListener('mouseleave', () => {
                this.show = false;

                setTimeout(() => {
                    if (!this.show) {
                        this.popoverInst.hide();
                        this.show = false;
                    }
                }, 100)
            });
        },

        getSubscriptionDate(date) {
            if (date) {
                const monthNumber = parseInt(date.substring(0, 2));
                const calendar = {
                    1: 'Janvier',
                    2: 'Février',
                    3: 'Mars',
                    4: 'Avril',
                    5: 'Mai',
                    6: 'Juin',
                    7: 'Juillet',
                    8: 'Août',
                    9: 'Septembre',
                    10: 'Octobre',
                    11: 'Novembre',
                    12: 'Décembre'
                }

                const month = calendar[monthNumber];
                const year = date.substring(3, 7);

                return `${month} ${year}`;
            }

            return null;
        },

        async getUser(id) {
            if (this.ajaxReq) {
                this.ajaxReq.cancel('stop');
            }

            this.ajaxReq = axios.CancelToken.source();

            axios.get(`/api/v1/users/${id}`, {
                cancelToken: this.ajaxReq.token,

            }).then((response) => {
                this.userData = response.data;

            }).then(() => {
                this.showPopover();

            }).catch((error) => {
                console.log('Erreur ! ' + error);
            })
        },

        hideOtherPopins(uniqueId) {
            this.$root.$emit('hide-other-popins', uniqueId);
        },

        hidePopin(uniqueId) {
            if (uniqueId !== this.uniqueId) {
                if (this.popoverInst) {
                    this.popoverInst.hide();
                }
                this.show = false;
            }
        },

        async showPopover() {
            if (!this.popoverInst) {
                this.popoverInst = new bootstrap.Popover(this.popover);
            }
            const userCertification = this.userData.certified === 1 ? 'Vérifié' : 'Non vérifié';
            const userCertificationCss = this.userData.certified === 1 ? 'verified' : 'not-verified';
            const subscriptionDate = this.getSubscriptionDate(this.userData.subscriptionDate);

            let specialStatus = '';

            if (this.userData.status === 'Ambassadeur') {
                specialStatus =
                    '                <h2 class="h3-like fs-5 mb-2 mt-3">Son statut spécial</h2>' +
                    '                <p class="lh-sm profile-info mb-0">Les Ambassadeurs sont sélectionnés par un jury, leurs avis sont détaillés, minutieux, étoffés, ils sont le "porte-drapeau" de Justacoté et on peut compter sur eux.</p>' +
                    '                </div>' +
                    '                ';
            }

            let localization = '';

            if (this.userData.city || this.userData.department) {
                localization = '<p class="profile-info mb-0">';

                if (this.userData.city.name) {
                    localization += this.userData.city.name;
                }

                if (this.userData.department) {
                    localization += (this.userData.city.name ? ', ' : '') + this.userData.department.name;
                }

                localization += '</p>';
            }

            let description = '';

            if (this.userData.description) {
                description = '<h2 class="h3-like fs-5 mb-2 mt-3">Sa présentation</h2> <p class="lh-sm profile-info mb-0">' + this.userData.description + '</p>';
            }

            let tags;

            if (this.userData.tags) {
                tags = ' <p class="lh-sm profile-info mb-0">' + this.userData.tags + '</p>';
            } else {
                tags = ' <p class="lh-sm profile-info mb-0">' + this.userData.pseudo + ' n\'a pas rempli ses centres d\'intérêt.</p>';
            }

            this.popoverInst._config.content = '<div class="popinWindow' + this.uniqueId + '">' +
                '                <h2 class="h3-like fs-5 mb-2">' + this.userData.pseudo + '</h2>' +
                '                <div class="user-favorite d-flex justify-content-center mb-1">' +
                '                    <div class="favorite-profile">' +
                '                        <img src="' + this.userData.avatar + '" alt="' + this.userData.pseudo + '" class="favorite-profile-picture image-like mb-2">' +
                '                    </div>' +
                '                    <div class="favorite-data">' +
                '                        <div class="favorite-data-info mb-2 d-flex justify-content-start">' +
                '                            <div class="favorite-data-info-icon image-like ' + this.userData.statusClass + '"></div>' +
                '                            <p class="favorite-data-info-text">' + this.userData.status + '</p>' +
                '                        </div>' +
                '                        <div class="favorite-data-info mb-2 d-flex justify-content-start">' +
                '                            <div class="favorite-data-info-icon image-like info-icon-sprite ' + userCertificationCss + '"></div>' +
                '                            <p class="favorite-data-info-text">' + userCertification + '</p>' +
                '                        </div>' +
                '                        <div class="favorite-data-info mb-2 d-flex justify-content-start">' +
                '                            <div class="favorite-data-info-icon image-like info-icon-sprite reviews"></div>' +
                '                            <p class="favorite-data-info-text">' + this.userData.reviewsCount + ' avis</p>' +
                '                        </div>' +
                '                        <div class="favorite-data-info mb-2 d-flex justify-content-start">' +
                '                            <div class="favorite-data-info-icon image-like info-icon-sprite points"></div>' +
                '                            <p class="favorite-data-info-text">' + this.userData.points + ' points</p>' +
                '                        </div>' +
                '                        <div class="favorite-data-info mb-2 d-flex justify-content-start">' +
                '                            <div class="favorite-data-info-icon image-like info-icon-sprite useful"></div>' +
                '                            <p class="favorite-data-info-text">' + this.userData.usefulsReceivedCount + ' Utile reçus</p>' +
                '                        </div>' +
                '                        <div class="favorite-data-info mb-2 d-flex justify-content-start">' +
                '                            <div class="favorite-data-info-icon image-like info-icon-sprite smile"></div>' +
                '                            <p class="favorite-data-info-text">' + this.userData.smilesReceivedCount + ' Smile reçus</p>' +
                '                        </div>' +
                '                    </div>' +
                '                </div>' +
                (subscriptionDate ? '                <p class="profile-info mb-0">Membre depuis ' + subscriptionDate + '</p>' : '')
                + localization +
                '                <a class="btn btn-red px-5 mt-2" href="' + this.userData.link + '">Voir le profil complet</a>'
                + description +
                '<h2 class="h3-like fs-5 mb-2 mt-3">Ses centres d"intérêt</h2>'
                + tags
                + specialStatus;

            this.show = true;

            setTimeout(() => {
                if (this.show && this.stillOn) {

                    this.popoverInst.show();
                    this.addListeners(this.popover);
                }
            }, 100)
        },
    }
};
</script>
